export default __webpack_public_path__ + "static/media/Group107.3f7c46f9.png";